import app from 'flarum/forum/app';
import Notification from 'flarum/components/Notification';
// import { isPermanentSuspensionDate } from '../helpers/suspensionHelper';

export default class FrontFailedNotification extends Notification {
  icon() {
    return '';
  }

  img() {
    return `${app.data.pkgLogo.cdnUrl}/${app.data.pkgLogo.ossFile}/img-zt-tj.png`;
  }

  href() {
    let post = this.attrs.notification.subject();
    if (!post) {
      return;
    }
    return app.route.post(post);
  }

  content() {
    const notification = this.attrs.notification;
    const title = notification.content().title;
    const isFronts = notification.content().isFronts;
   
    return app.translator.trans( `dl_discussion_controller.forum.notices.reject_${isFronts ? 'push' : 'pull'}_front`,
    {title:title});

  }
}
